import { render } from "./StudentMessagesBlock.vue?vue&type=template&id=a22a6116&scoped=true"
import script from "./StudentMessagesBlock.vue?vue&type=script&lang=js"
export * from "./StudentMessagesBlock.vue?vue&type=script&lang=js"

import "./StudentMessagesBlock.vue?vue&type=style&index=0&id=a22a6116&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-student/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a22a6116"]])

export default __exports__